import { Color } from "../enums/Color";

const button = {
    height: "44px",
    padding: "0 32px",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "8px",
    cursor: "pointer"
};

// Positioned wrapper so the absolute dropdown panel takes the field's width, not the page's
const select = {
    wrapper: {
        position: "relative" as "relative",
        width: "100%",
        marginLeft: "unset",
        zIndex: "3"
    },
    hover: {
        width: "100%",
        height: "320px",
        left: "0",
        padding: "5px",
        boxSizing: "border-box" as "border-box"
    }
};

export const videoLessonEditPage = {
    mobile: {
        margin: "16px 4% 40px 4%",
        heading: {
            textAlign: "center" as "center",
            margin: "0 0 32px 0"
        },
        columns: {
            display: "flex",
            flexDirection: "column" as "column",
            gap: "24px"
        },
        column: {
            flex: 1
        },
        section: {
            marginBottom: "20px"
        },
        // No top margin: sections space themselves, and both columns must start level
        label: {
            display: "block",
            fontWeight: "bold",
            color: Color.DeepAsh,
            margin: "0 0 8px 0"
        },
        // Teacher sits above the subject field, so its open dropdown must stack over it
        teacherSelect: {
            ...select,
            wrapper: { ...select.wrapper, zIndex: "4" }
        },
        subjectSelect: select,
        switchWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            alignItems: "center",
            gap: "16px",
            marginBottom: "20px",
            cursor: "pointer"
        },
        switchLabel: {
            fontWeight: "bold",
            color: Color.DeepAsh
        },
        editor: {
            minHeight: "240px",
            border: "2px solid " + Color.Green,
            borderRadius: "8px"
        },
        image: {
            width: "100%",
            maxHeight: "260px",
            objectFit: "contain" as "contain",
            border: "2px solid " + Color.Green,
            borderRadius: "8px",
            cursor: "pointer"
        },
        placeholder: {
            height: "160px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: Color.SharpAsh,
            border: "2px dashed " + Color.Green,
            borderRadius: "8px",
            cursor: "pointer"
        },
        invalidBorder: {
            borderColor: Color.Red
        },
        invalidMessage: {
            color: Color.Red,
            fontSize: "13px",
            marginTop: "6px"
        },
        video: {
            width: "100%",
            borderRadius: "8px",
            backgroundColor: Color.Black
        },
        warningText: {
            color: Color.HarvestGold,
            fontWeight: "bold"
        },
        fileButton: {
            display: "inline-block",
            marginTop: "10px",
            padding: "8px 16px",
            color: Color.ChathamsBlue,
            border: "2px solid " + Color.ChathamsBlue,
            borderRadius: "8px",
            fontWeight: "bold",
            cursor: "pointer"
        },
        link: {
            display: "block",
            color: Color.ChathamsBlue,
            fontWeight: "bold"
        },
        summary: {
            container: {
                padding: "16px",
                marginBottom: "20px",
                backgroundColor: Color.LightAsh,
                borderRadius: "8px"
            },
            subjects: {
                fontSize: "18px",
                fontWeight: "bold",
                color: Color.ChathamsBlue
            },
            muted: {
                fontSize: "13px",
                color: Color.SharpAsh,
                marginTop: "4px"
            },
            pendingState: {
                display: "inline-block",
                marginTop: "10px",
                padding: "4px 12px",
                fontWeight: "bold",
                color: Color.HarvestGold,
                backgroundColor: Color.OldLace,
                borderRadius: "12px"
            },
            approvedState: {
                display: "inline-block",
                marginTop: "10px",
                padding: "4px 12px",
                fontWeight: "bold",
                color: Color.Viridian,
                backgroundColor: Color.Nyanza,
                borderRadius: "12px"
            }
        },
        buttonWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "16px",
            marginTop: "24px"
        },
        savingText: {
            color: Color.SharpAsh,
            fontWeight: "bold"
        },
        // Sits on the left, apart from the save buttons on the right
        backButton: {
            ...button,
            background: Color.White,
            color: Color.DeepAsh,
            border: "2px solid " + Color.MiddleAsh,
            marginRight: "auto"
        },
        secondaryButton: {
            ...button,
            background: Color.White,
            color: Color.Green,
            border: "2px solid " + Color.Green
        },
        primaryButton: {
            ...button,
            background: Color.Green,
            color: Color.White,
            border: "2px solid " + Color.Green
        },
        disabledButton: {
            opacity: 0.5,
            cursor: "not-allowed"
        },
        responseDialog: {
            backdrop: {
                backgroundColor: Color.Black,
                opacity: 0.15,
                position: "fixed" as "fixed",
                left: "0",
                right: "0",
                bottom: "0",
                top: "0"
            },
            content: {
                background: Color.White,
                position: "fixed" as "fixed",
                top: "35%",
                left: "5%",
                width: "80%",
                padding: "10px 5% 20px 5%",
                borderRadius: "10px",
                zIndex: "4",
                boxShadow: "1px 0px 7px rgba(0,0,0,0.5)"
            }
        },
        responseTitle: {
            color: Color.Green
        },
        responseButton: {
            backgroundColor: Color.Green,
            color: Color.White,
            border: "none",
            borderRadius: "8px",
            padding: "10px 24px",
            float: "right" as "right",
            cursor: "pointer"
        }
    },
    desktop: {
        margin: "16px 8% 40px 8%",
        columns: {
            flexDirection: "row" as "row",
            gap: "48px"
        },
        responseDialog: {
            content: {
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "32%",
                padding: "2%"
            }
        }
    }
}
